import { createRouter, createWebHistory } from "vue-router"
import VueRouteMiddleware from "vue-route-middleware"

import auth from '@/middleware/auth'
import AccessDenied from "@/views/Pages/AccessDenied.vue"

const routes = [
	{
		path: "/",
		name: "index",
		redirect: "main",
		meta: {
			middleware: [auth],
		},
	},
	// {
	// 	path: "/login",
	// 	name: "login",
	// 	component: () => import("@/views/Pages/Login.vue"),
	// 	meta: {
	// 		middleware: [auth],
	// 	},
	// },
	{
		path: "/form/internal",
		name: "leadForm_internal",
		component: () => import("@/views/Pages/LeadForm_Internal.vue"),
	},
	{
		path: "/form/client-proposals/:unique_key/:access_key",
		name: "clientProposal",
		component: () => import("@/views/Pages/Proposals/ClientProposal.vue"),
		props: true,
	},
	// ---- Public client-facing contract routes (no auth required) ----
	{
		path: "/form/client-contracts/:unique_key/:access_key",
		name: "clientContract",
		component: () => import("@/views/Pages/Contracts/ClientContract.vue"),
		props: true,
	},
	{
		path: '/renew-contract/:unique_key/:access_key',
		name: 'RenewContract',
		component: () => import("@/views/Pages/Contracts/ClientContractRenewal.vue"),
		props: true
	},
	{
		path: '/contract/deleted-not-exist',
		name: 'ContractDeletedNonExist',
		component: () => import("@/views/Pages/Contracts/ContractDeleted.vue"),
		props: true
	},
	{
		path: '/contract/no-access',
		name: 'ContractNoAccess',
		component: () => import("@/views/Pages/Contracts/ContractNoAccess.vue"),
		props: true
	},
	{
		path: '/expired-contract/:unique_key/:access_key',
		name: 'ContractExpired',
		component: () => import("@/views/Pages/Contracts/ClientContractExpired.vue"),
		props: true
	},
	{
		path: '/form/feedback/contract/:unique_key/:access_key',
		name: 'ContractFeedback',
		component: () => import("@/views/Pages/Contracts/ContractFeedback.vue"),
		props: true
	},
	{
		path: '/renew-proposal/:unique_key/:access_key', // Add placeholders for the keys
		name: 'RenewProposal',
		component: () => import("@/views/Pages/Proposals/ClientProposalRenewal.vue"),
		props: true // This allows the component to receive the keys as props
	},
	{
		path: '/messages/thank-you', // Add placeholders for the keys
		name: 'ThankYouPage',
		component: () => import("@/views/Pages/ThankYou.vue"),
		props: true // This allows the component to receive the keys as props
	},
	{
		path: '/pentester/messages/thank-you', // Add placeholders for the keys
		name: 'ThankYouPagePentester',
		component: () => import("@/views/Pages/ThankYou.vue"),
		props: true // This allows the component to receive the keys as props
	},
	{
		path: '/contact-page/messages/thank-you', // Add placeholders for the keys
		name: 'ThankYouPageContactPage',
		component: () => import("@/views/Pages/ThankYou.vue"),
		props: true // This allows the component to receive the keys as props
	},
	{
		path: '/proposal/thank-you',
		name: 'ProposalThankYou',
		component: () => import("@/views/Pages/ProposalThankYou.vue"),
		props: true
	},
	{
		path: '/messages/page-under-construction', // Add placeholders for the keys
		name: 'PageUnderConstruction',
		component: () => import("@/views/Pages/PageBeingConstructed.vue"),
		props: true // This allows the component to receive the keys as props
	},
	{
		path: '/proposal/deleted-not-exist', // Add placeholders for the keys
		name: 'ProposalDeletedNonExist',
		component: () => import("@/views/Pages/Proposals/ProposalDeleted.vue"),
		props: true // This allows the component to receive the keys as props
	},
	{
		path: '/proposal/no-access', // Add placeholders for the keys
		name: 'ProposalNoAccess',
		component: () => import("@/views/Pages/Proposals/ProposalNoAccess.vue"),
		props: true // This allows the component to receive the keys as props
	},
	{
		path: '/expired-proposal/:unique_key/:access_key', // Add placeholders for the keys
		name: 'ProposalExpired',
		component: () => import("@/views/Pages/Proposals/ClientProposalExpired.vue"),
		props: true // This allows the component to receive the keys as props
	},
	{
		path: '/form/feedback/:unique_key/:access_key', // Add placeholders for the keys
		name: 'ProposalFeedback',
		component: () => import("@/views/Pages/Proposals/ProposalFeedback.vue"),
		props: true // This allows the component to receive the keys as props
	},
	{
		path: "/form/penetration-testing",
		name: "leadForm_pentest",
		component: () => import("@/views/Pages/LeadForm_Pentest.vue"),
	},
	{
		path: "/form/contact",
		name: "leadForm_contactPage",
		component: () => import("@/views/Pages/LeadForm_ContactPage.vue"),
	},
	{
		path: "/internal/form/contact-form",
		name: "leadForm_internalContactForm",
		component: () => import("@/views/Pages/LeadForm_InternalContactForm.vue"),
	},
	{
		path: "/form/internal/contact-form",
		name: "leadForm_internalContactForm_alias",
		component: () => import("@/views/Pages/LeadForm_InternalContactForm.vue"),
	},
	{
		path: "/validation",
		name: "validation",
		component: () => import("@/views/Validation.vue"),
	},
	{
		path: "/access-denied",
		name: "AccessDenied",
		component: AccessDenied,
		meta: {
			title: "Access Denied - Spark",
			requiresAuth: false,
		},
	},
	{
		path: "/demo/proposal/wysiwyg",
		name: "Wysiwyg",
		component: () => import("@/views/Pages/Proposals/Wysiwyg.vue"),
	},
	{
		path: "/main",
		name: "main",
		component: () => import("@/views/Main.vue"),
		meta: {
			middleware: [auth],
		},
		redirect: "dashboard",
		children: [
			{
				path: "/dashboard",
				name: "dashboard",
				component: () => import("@/views/Pages/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/cron",
				name: "cron",
				component: () => import("@/views/Pages/Cron/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/debugger",
				name: "debugger",
				component: () => import("@/views/Pages/Debugger/Debugger.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/client-questions",
				name: "ClientQuestions",
				component: () => import("@/views/Pages/Questions/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/leads",
				redirect: to => ({ path: '/leads-v2', query: to.query }),
			},
			{
				path: "/leads-v2",
				name: "leads_v2",
				component: () => import("@/views/Pages/Leads/DashboardV2.vue"),
				meta: {
					requiresAuth: true,
				},
				children: [
					{
						path: ":id",
						name: "leads-v2-view",
						component: () => import("@/components/Leads/Sidebar.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
					},
				],
			},
			{
				path: "/proposals",
				redirect: to => ({ path: '/proposals-v2', query: to.query }),
			},
			{
				path: "/proposals-v2",
				name: "proposals_v2",
				component: () => import("@/views/Pages/Proposals/DashboardV2.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/contracts",
				redirect: to => ({ path: '/contracts-v2', query: to.query }),
			},
			{
				path: "/contracts-v2",
				name: "contracts_v2",
				component: () => import("@/views/Pages/Contracts/DashboardV2.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/product-pricing",
				name: "product_pricing",
				component: () => import("@/views/Pages/ProductPricing/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/bdm-details",
				name: "bdm_details",
				component: () => import("@/views/Pages/BDMDetails/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/dynamic-variables",
				name: "dynamic_variables",
				component: () => import("@/views/Pages/DynamicVariables/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/content-library",
				name: "content-library",
				component: () => import("@/views/Pages/ContentLibrary/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/content-library/blocks",
				name: "content_library_blocks",
				component: () => import("@/views/Pages/ContentLibrary/BlockDashboard.vue"),
				// children: [
				// 	{
				// 		path: ":id",
				// 		name: "control-view",
				// 		component: () => import("@/components/catalogue/controls/Sidebar.vue"),
				// 		props: true,
				// 		meta: {
				// 			requiresAuth: true,
				// 		},
				// 	},
				// ],
			},
			{
				path: "/blocks/:id",
				name: "block-tab-view",
				component: () => import("@/views/Pages/ContentLibrary/BlockView.vue"),
				props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/proposals/:id",
				name: "proposal-view",
				component: () => import("@/views/Pages/Proposals/ProposalView.vue"),
				props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/contracts/:id",
				name: "contract-view",
				component: () => import("@/views/Pages/Contracts/ContractView.vue"),
				props: true,
				meta: {
					requiresAuth: true,
				},
			},
			// contract public routes moved to top-level (no auth required)
			{
				path: "/content-library/testimonials",
				name: "content_library_testimonials",
				component: () => import("@/views/Pages/ContentLibrary/TestimonialDashboard.vue"),
				children: [
					{
						path: ":id",
						name: "testimonial-view",
						component: () => import("@/components/ContentLibrary/TestimonialDetailedView.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
					},
				],
			},
			{
				path: "/content-library/contract-templates",
				name: "content_library_contract_tempaltes",
				component: () => import("@/views/Pages/ContentLibrary/ContractTemplatesDashboard.vue"),
				children: [
					// {
					// 	path: ":id",
					// 	name: "testimonial-view",
					// 	component: () => import("@/components/ContentLibrary/TestimonialDetailedView.vue"),
					// 	props: true,
					// 	meta: {
					// 		requiresAuth: true,
					// 	},
					// },
				],
			},
			{
				path: "/testimonials/:id",
				name: "testimonial-tab-view",
				component: () => import("@/views/Pages/ContentLibrary/TestimonialView.vue"),
				props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/contract-settings",
				name: "contract_settings",
				component: () => import("@/views/Pages/ContractSettings/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/maintenance-settings/dashboard",
				name: "maintenanceSettings_Dashboard",
				component: () => import("@/views/Pages/MaintenanceSettings/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/platform-settings/user-settings",
				alias: ["/user-settings"],
				name: "platform_user_settings",
				component: () => import("@/views/Pages/UserSettings/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/admin/jobs-catalogue",
				name: "jobs_catalogue",
				component: () => import("@/views/Pages/JobsCatalogue/JobsCatalogueDashboard.vue"),
				meta: {
					requiresAuth: true,
					requiresSuperAdmin: true,
				},
			},
			{
				path: "/admin/jobs-catalogue/blueprint/:id?",
				name: "job_blueprint_editor",
				component: () => import("@/views/Pages/JobsCatalogue/JobBlueprintEditor.vue"),
				meta: {
					requiresAuth: true,
					requiresSuperAdmin: true,
				},
				props: true,
			},
			{
				path: "/jobs-catalogue",
				redirect: "/admin/jobs-catalogue",
			},
			{
				path: "/jobs",
				redirect: "/admin/jobs-catalogue",
			},
			{
				path: "/job",
				redirect: "/admin/jobs-catalogue",
			},
			{
				path: "/job-catalogue",
				redirect: "/admin/jobs-catalogue",
			},
			{
				path: "/clients/dashboard",
				name: "clients-dashboard",
				component: () => import("@/views/Pages/Clients/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/clients/view-clients",
				name: "clients-view",
				component: () => import("@/views/Pages/Clients/ViewClients.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/regression-library",
				name: "regression_library",
				component: () => import("@/views/Pages/RegressionLibrary/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/quick-links",
				name: "quick_links",
				// Cache invalidation trigger for newly created directory
				component: () => import("@/views/Pages/QuickLinks/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/jira-analytics",
				name: "jira_analytics",
				component: () => import("@/views/Pages/JiraAnalytics/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/platform-guide",
				name: "platform_guide",
				component: () => import("@/views/Pages/PlatformGuide/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/platform-releases",
				name: "platform_releases",
				component: () => import("@/views/Pages/PlatformReleases/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/platform-bug-reporting",
				name: "platform_bug_reporting",
				component: () => import("@/views/Pages/PlatformBugReporting/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/platform-hub",
				alias: ["/platforms"],
				name: "platform_hub",
				component: () => import("@/views/Pages/PlatformHub/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
		],
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

router.beforeEach(VueRouteMiddleware({ auth }))

export default router;
